export const selectOrganizationState = state => state.organizationState;
export const selectNormalizedOrgs = state =>
  state.organizationState.normalizedOrgs;
export const selectOrgID = state => state.organizationState.selectedOrg?.id;
